import { getFirestore, getDocs, collection, where, query, getCountFromServer } from "firebase/firestore";
import { DateTime } from "luxon";
import personalDocumentConverter from "../converters/personalDocumentConverter";
import { PersonalDocumentType } from "../types/PersonalDocument";

export const queryPersonalDocumentsCountExpiresIn = async (type: PersonalDocumentType, month: number = 3) => {
  return (await getCountFromServer(query(collection(getFirestore(), `PersonalDocuments/${type}/List`), where('expire', '<=', DateTime.utc().plus({ month }).toFormat('yyyyMMdd'))))).data().count;
};

export const queryPersonalDocumentsExpiresIn = async (type: PersonalDocumentType, month: number = 3) => {
  return await getDocs(query(
    collection(getFirestore(), `PersonalDocuments/${type}/List`),
    where('expire', '<=', DateTime.utc().plus({ month }).toFormat('yyyyMMdd'))
  ).withConverter(personalDocumentConverter)).then(qSnapshot => {
    return qSnapshot.docs.map(dSnapshot => dSnapshot.data());
  });
}

export const queryPassportDocumentsCountExpiresIn = async (month: number = 3) => {
  return await queryPersonalDocumentsCountExpiresIn('Passport', month)
};

export const queryPassportDocumentsExpiresIn = async (month: number = 3) => {
    return await queryPersonalDocumentsExpiresIn('Passport', month);
};